/**
 * 구분별 발주처, 하위 사용 어플, 계약 유형 연동 데이터
 */

export interface CategoryConfig {
  orderers: string[];
  subApps: string[];
  contractTypes: string[];
}

export const CATEGORY_OPTIONS_MAP: Record<string, CategoryConfig> = {
  'KYS(B2B)': {
    orderers: [
      '자이', 'HDC랩스', '코콤', '효성ITX', '하이텍네트웍스', '퍼니포커스',
      '거진이앤씨', '창조통신', '아이디스', '투윈스컴', '한영정보통신', '에시르',
      '유앤티네트웍스', '반도산전', '에이앤티', '하나비젼시스템즈', '대선정보통신',
      '이화일렉콤', '동영미디어', '홀리랜드테크놀러지', '유앤테크', '씨큐어밸리',
      '비앤에스', '오무전력', '동영엠텍', '에스와이시스템', '참조은정보통신',
      '대우에스티', '태호네트웍스', '한양', '동우이앤티', '투피스', '에스케이테크',
      '씨아이시스템', '두레정보통신', '다산카이스', '승일전기',
    ],
    subApps: ['마이타운', '자이패스', '오이패스', '노크타운', '스마트원', '아파트너', '아파트스토리', '스마트패스', '코콤'],
    contractTypes: ['납품계약', '유지계약', '세대계약'],
  },
  'KYS(B2C)': {
    orderers: ['SK쉴더스', '아파트스토리', '아파트너', '지앤톡', '트러스테이', '다산카이스'],
    subApps: ['마이타운', '노크타운', '아파트스토리', '아파트너', '오이패스'],
    contractTypes: ['납품계약', '단지계약', '세대계약', '개별계약'],
  },
  '신관산업': {
    orderers: ['신관산업', '신관(B2C)'],
    subApps: ['스마트패스'],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
  '유니콤': {
    orderers: ['유니콤', '다산카이스'],
    subApps: ['마이타운'],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
  '이엠테크': {
    orderers: ['이엠테크', '다산카이스'],
    subApps: ['마이타운'],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
  '럭스로보': {
    orderers: ['럭스로보', '다산카이스'],
    subApps: [],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
  '삼우': {
    orderers: ['삼우', '다산카이스'],
    subApps: ['마이타운'],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
  '라온': {
    orderers: ['라온', '다산카이스'],
    subApps: ['마이타운'],
    contractTypes: ['납품계약', '유지계약', '단지계약', '세대계약'],
  },
};

/** 모든 구분 목록 */
export const ALL_CATEGORIES = Object.keys(CATEGORY_OPTIONS_MAP);

/** 모든 발주처 (중복 제거, 정렬) */
export const ALL_ORDERERS = [...new Set(
  Object.values(CATEGORY_OPTIONS_MAP).flatMap((c) => c.orderers),
)].sort();

/** 모든 하위 사용 어플 (중복 제거) */
export const ALL_SUB_APPS = [...new Set(
  Object.values(CATEGORY_OPTIONS_MAP).flatMap((c) => c.subApps),
)].sort();

/** 모든 계약 유형 (중복 제거) */
export const ALL_CONTRACT_TYPES = [...new Set(
  Object.values(CATEGORY_OPTIONS_MAP).flatMap((c) => c.contractTypes),
)].sort();
